global.window = {};
